export const getFileNameFromUrl = (fileUrl: string) => {
  let decodedUrl = decodeURI(fileUrl);
  let urlSplits = decodedUrl.split("/");
  return urlSplits[urlSplits.length - 1];
};

// A function to compare two objects deeply
export const areObjectsEqual = (objA: any, objB: any) => {
  if (objA == null || objB == null) {
    return objA === objB;
  }
  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) {
    return false;
  }
  if (Array.isArray(objA)) {
    if (objA.length != objB.length) {
      return false;
    } else {
      let returns = objA.map((arrayItem: any, index: number) => {
        if (typeof objA[index] == "object") {
          if (!areObjectsEqual(objA[index], objB[index])) {
            return false;
          }
        } else if (!objA.includes(objB[index]) || !objB.includes(objA[index])) {
          return false;
        }
      });
      if (returns.includes(false)) {
        return false;
      }
    }
  } else {
    for (const key of keysA) {
      if (
        objA[key] != null &&
        typeof objA[key] === "object" &&
        typeof objB[key] === "object"
      ) {
        if (!areObjectsEqual(objA[key], objB[key])) {
          return false;
        }
      } else {
        let vulnerablities = [undefined, null, -1, 0, "", ""];
        if (
          vulnerablities.includes(objA[key]) &&
          vulnerablities.includes(objA[key]) ===
            vulnerablities.includes(objB[key])
        ) {
          continue;
        } else if (
          objA[key] === undefined ||
          (typeof objB[key] == "boolean"
            ? objA[key].toString() != objB[key].toString()
            : objA[key] != objB[key])
        ) {
          return false;
        }
      }
    }
  }
  return true;
};

export const persistVariables = (values: Record<string, any>) => {
  let localStorageItem = localStorage.getItem("lis-params");
  let params: any = localStorageItem ? JSON.parse(localStorageItem) : {};
  let updatedParams = { ...params, ...values };
  localStorage.setItem("lis-params", JSON.stringify(updatedParams));
};

export const getPersistedValues = (paramsToRetrieve: string[]): any => {
  let localStorageItem = localStorage.getItem("lis-params");
  let params: any = localStorageItem ? JSON.parse(localStorageItem) : {};
  let retrievedValues: Record<string, any> = {};

  if (paramsToRetrieve.length > 1) {
    for (const param of paramsToRetrieve) {
      retrievedValues[param] = params[param];
    }
  } else {
    retrievedValues[paramsToRetrieve[0]] = params[paramsToRetrieve[0]];
  }

  return retrievedValues as any;
};

export const removePersistedVariables = (paramsToRemove: string[]) => {
  let localStorageItem = localStorage.getItem("lis-params");
  let params: any = localStorageItem ? JSON.parse(localStorageItem) : {};
  paramsToRemove.forEach((item: string) => {
    delete params[item];
  });
  localStorage.setItem("lis-params", JSON.stringify(params));
};
